import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import da from "./dictionaries/da.json";
import en from "./dictionaries/en.json";

i18next
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		lng: "da",
		debug: true,
		fallbackLng: "en",
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		resources: {
			en,
			da
		},
	});

// i18next.services.formatter.add('lowercase', (value, lng, options) => {
// 	return value.toLowerCase();
// });
// i18next.services.formatter.add('capitalize', (value, lng, options) => {
// 	return `${value.substr(0, 1).toUpperCase()}${value.substr(1).toLowerCase()}`;
// });


export default i18next;
